import {setBackendError} from "../actions";
import {TStore} from "./types";
import {UserManager} from "oidc-client-ts";
import {
    createErrorHandlerLink as createLink,
    ErrorHandlerStrategy,
    GQLErrorHandlerArgs,
    UnknownErrorCodeHandlerArgs,
    ProtocolErrorHandlerArgs,
    BackendErrorCode,
    NetworkErrorHandlerArgs,
} from "@dvrt/graphql-widgets/apollo";
import {heimdallAuthStrategy} from "@dvrt/graphql-widgets/apollo";

/**
 * Catches and handles GQL errors returned from the backend.
 */
export const createErrorHandlerLink = (store: TStore, userManager: UserManager) => {
    const heimdallErrorHandler = (details: string) => {
        store.dispatch(setBackendError({code: "cant_reach_heimdall", details}));
    };

    const dispatchBackendError = ({error, code}: GQLErrorHandlerArgs | UnknownErrorCodeHandlerArgs) => {
        store.dispatch(
            setBackendError({
                code: code as BackendErrorCode,
                details: `Message: ${error.message}` + (error.path ? `\nPath: ${error.path.join(".")}` : ""),
            }),
        );
    };

    const handleProtocolError = ({errors}: ProtocolErrorHandlerArgs) => {
        const error = errors[0]!;
        const code = (error.extensions?.code as BackendErrorCode) ?? "INTERNAL_SERVER_ERROR";

        store.dispatch(
            setBackendError({
                code,
                details: `Message: ${error.message}` + (error.path ? `\nPath: ${error.path.join(".")}` : ""),
            }),
        );
    };

    const handleNetworkError = ({error}: NetworkErrorHandlerArgs) => {
        console.error("Network error occurred:", error);
        store.dispatch(setBackendError({code: "UNREACHABLE"}));
    };

    const strategy: ErrorHandlerStrategy = {
        // Use standardized Heimdall auth strategy for handling authentication and authorization errors
        ...heimdallAuthStrategy(userManager, heimdallErrorHandler),

        // Handle other Concerto-Web specific errors
        onInternalServerError: dispatchBackendError,
        onBadUserInput: dispatchBackendError,
        onUnknownErrorCode: dispatchBackendError,
        onProtocolError: handleProtocolError,
        onNetworkError: handleNetworkError,
    };

    return createLink(strategy);
};
